import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import React from "react";

export const ModalCargando = ({ open, title, subtitule }) => {
    return (
        <>
            <Modal className="text-center" isOpen={open} centered={true}>
                <ModalHeader className="justify-content-center title" tag="h4">
                    {title}
                </ModalHeader>
                <ModalBody>
                    <h5 className={""}>{subtitule}</h5>
                </ModalBody>
                <ModalFooter></ModalFooter>
            </Modal>
        </>
    );
};
